<template>
   <div class="course_repertoire">
     <ul class="audio_list">
        <li
          v-for="(track, index) in paginationClassData"
          :key="track.id"
          :class="{'audio_disabled': track.free === false || track.status === false,
            'audio_bg_dark': !track.status
            }"
          class="audio_item"
        >
        <!-- track.status === false -->
            <div class="track_btn">
              <button
              @click="getAudio(track, index)"
              :disabled="track.free === false || track.status === false"
              class="button"
              >
                <i
                  v-show="trackInfo.trackId !== track.id || !isPlaying"
                  class="fas fa-play"
                ></i>
                <i
                  v-show="trackInfo.trackId === track.id && isPlaying"
                  class="fas fa-pause"
                ></i>
              </button>
              <p v-show="track.free === true" class="audition_text">試聽</p>
              <div
                @click="showDisabledMessage"
                v-show="track.free === false || track.status === false"
                class="click_disabled_message"
              ></div>
            </div>
            <div class="track_content">
              <div class="track_title">
                <span>
                  {{track.num}}
                </span>
                {{track.title}}
              </div>
              <div v-if="track.status === true" class="track_right">
                  <div class="track_date">
                    {{ track.updated_at }}
                  </div>
                  <div class="track_length">
                    {{ track.timeLength }}
                  </div>
              </div>
              <div v-if="track.status === false" class="track_right">
                內容將陸續更新
              </div>
            </div>
        </li>
      </ul>

      <div v-show="totalPages > 1" class="pagiContainer">
        <ClientsPagination
          :current-page.sync="currentPage"
          :total-pages="totalPages"
          v-on:change-list-page="changeListPage"
        />
      </div>
  </div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
import ClientsPagination from '@/components/views/clients/components/ClientsPagination'

export default {
  name: 'CourseRepertoire',
  components: {
    ClientsPagination
  },
  props: {
    channelID: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    authorTitle: {
      type: String,
      default: ''
    },
    imgCover: {
      type: String,
      default: ''
    },
    episodesList: {
      type: Array,
      default: () => []
    },
    paginationClassData: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      ttype: Number,
      default: 1
    }
  },
  computed: {
    ...mapState({
      trackList: state => state.audio.trackList,
      courseInfo: state => state.audio.courseInfo,
      trackInfo: state => state.audio.trackInfo
    }),
    isPlaying: {
      get () {
        return this.$store.state.audio.isPlaying
      },
      set (value) {
        this.$store.commit('audio/setIsPlaying', value)
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    ...mapActions('audio', [
      'setAudioList',
      'setCourseInfo',
      'setTrackInfo'
    ]),
    getAudio (track, index) {
      const vm = this

      // console.log('1: getAudio')
      // console.log(this.courseInfo.id)
      const coursePathname = window.location.pathname
      if (vm.courseInfo.id !== vm.channelID) {
        const courseInfo = {
          id: vm.channelID,
          title: vm.title,
          author: vm.authorTitle,
          imgCover: vm.imgCover,
          pathname: coursePathname
        }
        // console.log(courseInfo)
        this.setCourseInfo(courseInfo)
      }
      this.setAudioPlayList()
      this.trackInfo.trackId === track.id ? this.togglePlay() : this.setTrack(track)
    },
    setAudioPlayList () {
      const parseChannelEpisodes = this.episodesList.filter((episode) => {
        return episode.status !== false
      })
      const parseFreeChannelEpisodes = parseChannelEpisodes.filter((episode) => {
        return episode.free === true
      })
      // console.log(parseFreeChannelEpisodes)
      this.setAudioList(parseFreeChannelEpisodes)
    },
    togglePlay () {
      this.isPlaying = !this.isPlaying
    },
    setTrack (track) {
      // console.log('2: setTrack')
      console.log(this.trackList)
      const indexOfpalyList = this.trackList.findIndex(i => i.id === track.id)
      console.log(indexOfpalyList)
      const trackObj = {
        trackId: track.id,
        trackTitle: track.title,
        trackIsFree: track.free,
        trackIndex: indexOfpalyList
      }
      // console.log(trackObj)
      this.setTrackInfo(trackObj)
        .then((res) => {
          // console.log(res)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    showDisabledMessage () {
      this.$toast.show('下載APP 付費聆聽', 1500)
    },
    changeListPage (val) {
      this.$emit('change-list-page', val)
    }
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
.course_repertoire {
  .audio_list {
    margin-bottom: 80px;
    >*:not(:last-child) {
      margin-bottom: 10px;
    }
  }
  .audio_item {
    display: flex;
    background: rgba(230, 230, 230, 0.5);
    border-radius: 4px;
    .track_btn {
      display: flex;
      flex-direction: column;
      padding: 30px;
      position: relative;
      border-right: 1px solid rgba(0, 0, 0, 0.1);
      .button {
        border: 0;
        background-color: transparent;
        &:focus {
          border: 0;
          outline: 0;
        }
      }
      .audition_text {
        font-size: 1.2rem;
        color: #176E8D;
        margin-bottom: 0;
        align-self: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, 10px);
      }
      .click_disabled_message {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
      }
    }
    .track_content {
      flex: 1 1 auto;;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      .track_title {
        padding-right: 20px;
        align-self: center;
      }
      .track_right {
        font-size: 1.4rem;
        opacity: 0.5;
        display: flex;
        align-self: center;
        .track_date {
          margin-right: 20px;
        }
        .track_length {
          margin-right: 30px;
        }
      }
    }
  }
  .audio_disabled {
    .track_btn .button {
      cursor: default;
      color: #929292;
    }
    .track_content .track_title {
      color: rgba(0, 0, 0, 0.5);
    }
  }
  .audio_bg_dark {
    background-color: rgb(222, 222, 222);
  }
}

@media screen and (max-width: 767px){
  .course_repertoire .audio_item .track_content {
    display: flex;
    flex-flow: column;
    justify-content: center;
    padding: 10px;
    .track_title {
      padding-right: 0;
      margin-bottom: 10px;
    }
    .track_right {
      font-size: 1.2rem;
    }
    .track_title, .track_right {
      align-self: flex-start;
    }
  }
}

@media screen and (min-width: 768px){
  .course_repertoire .audio_item .track_content {
    .track_right {
      flex: 0 0 180px;
    }
  }
}

@media screen and (max-width: 375px){
  .course_repertoire .audio_item {
    .track_btn {
      padding: 30px 24px;
      align-self: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/Course/components/CourseRepertoire.vue